/**
 * Included into the footer of pages.
 */

import * as variables from './variables.js';

import './lib/AnimationEasing';

import "./lib/AnalyticsSetup"; 

import * as $ from 'jquery';

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import {MainMenu, CollapseExpandChildrenListener } from './component/MainMenu/MainMenu';
const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;
const mainMenu = new MainMenu({
	menu: '#menu',
	menuTriggers: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.menu-item-has-children > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(animationUnsupported ? 0 : 400, 'easeOutExpo')
	]
});

// Collapsible Group (needed for MOBILE product filters)
import './component/CollapsibleGroup';

// ===============================================================
// Search interfaces
// AjAX update search results
// (NOTE: Another library already pulls this in. Our debouncer does not restart the period as I want with a debouncer.)
// @ts-ignore
const debounce = require('just-debounce');

const $forms = $('form[data-ajax-rerender]');
if ($forms.length > 0) {

	const updateResultsDebounced = debounce((e: JQuery.TriggeredEvent) => {
		// Only update results on change if not mobile
		if (ViewportTracker.above('mobileMenu')) {
			updateResults(e.currentTarget as HTMLFormElement);
		}
	}, 800, false);

	$forms.on('input', function(e) {
		const $form = $(e.currentTarget as HTMLFormElement);
		startSpinner($form);

		updateResultsDebounced(e);
	});

	// Form submit, update results
	$forms.on('submit', (e) => {
		e.preventDefault();
		const form = e.currentTarget as HTMLFormElement;
		updateResults(form);

		// Only IF mobile
		if (ViewportTracker.below('mobileMenu')) {
			// If search accordion currently open (on mobile) then close it
			// NOTE: Code is highly coupled to CollapsibleGroup. Addressing would require remaking CollapsibleGroup.
			const $item = $(form).parents('div[data-item-id]');
			$item.trigger("changeActive", {
				itemId: $item.attr('data-item-id'),
				open: false
			});
		}
	});

	// If accordion is closed
	$forms.parents('.item--searchFilters').on('changeStateBefore', (e, data) => {
		if (data.currentOpen && !data.newOpen) {
			// Closing (was open)
			updateResults($(e.currentTarget).find('form[data-ajax-rerender]').get(0) as HTMLFormElement);
		}
		if (data.newOpen) {
			document.body.classList.add('hasSearchFiltersOpen');
		}
	});
	$forms.parents('.item--searchFilters').on('changeStateAfter', (e, data) => {
		if (!data.newOpen) {
			document.body.classList.remove('hasSearchFiltersOpen');
		}
	});

	window.onpopstate = function(event) {
		const queryString = location.search.substr(1);
		const params = new URLSearchParams(queryString);

		const $form = $('form[data-ajax-rerender]');

		// Update form fields.
		$form.find('input').each((index, input) => {
			if (input.type == 'checkbox') {
				input.checked = params.getAll(input.name).indexOf(input.value) !== -1;
			} else {
				input.value = params.get(input.name);
			}
		});

		// Update results
		updateResults($form.get(0) as HTMLFormElement, false);
	};

	// Toggle child / parent checkboxes
	$('form[data-ajax-rerender] ul input[type=checkbox]').on('change', (event) => {
		const $input = $(event.target);
		const $li = $input.parents('li:first');
		const checked = $input.is(':checked');

		/// Children / Accordion -----------------------------------
		// Checks or unchecks descendents
		$li.find('ul input[type=checkbox]').prop('checked', checked);

		// Open child accordions based on if checked
		$li.toggleClass('open', checked);

		/// Parent -----------------------------------
		// Uncheck or check parent
		const $parentLI = $li.parents('li:first');
		if ($parentLI.length > 0) {
			// Has a parent
			// Are all my siblings checked?
			const $checkedChildren = $parentLI.find('> ul > li > span > label > input:not(:checked)');
			const allChildrenChecked = $checkedChildren.length == 0;

			console.log('allChildrenChecked ', allChildrenChecked );
			$parentLI.find('> span > label > input').prop('checked', allChildrenChecked);
		}
	});

	// Toggle children accordion
	$('form ul li .childrenToggle').on('click', (event) => {
		event.preventDefault();
		const $target = $(event.target);
		$target.parent().parent().toggleClass('open');
	});

	// Redundant?
	$('form ul li .childrenToggle').on('keypress', (event) => {
		event.preventDefault();
		const $target = $(event.target);
		$target.parent().parent().toggleClass('open');
	});

	// NEW for J&P: Clear All Button
	$forms.on('reset', (e) => {
		const form = e.currentTarget as HTMLFormElement;

		updateResults(form, true, true);

		// This is needed if the URL has query parameters when the page initially loads
		$(':input').not(':button, :submit, :reset, :hidden').removeAttr('checked').removeAttr('selected').not(':checkbox, :radio, select').val('');
	});
}

function getRerender($form: JQuery<Element>) {
	const rerender = $form.attr('data-ajax-rerender');
	const $rerender = $(rerender);
	return $rerender;
}
function startSpinner($form: JQuery<Element>) {
	const $rerender = getRerender($form);
	$rerender.addClass('spinner');
}
function stopSpinner($form: JQuery<Element>) {
	const $rerender = getRerender($form);
	$rerender.removeClass('spinner');
}

let lastSearchQueryString = location.search.substring(1);
function updateResults(form: HTMLFormElement, updateState: boolean = true, reset?: boolean) {
	const $form = $(form);
	const $rerender = getRerender($form);
	
	let queryString = reset ? '' : $form.serialize();
	queryString = queryString.replace(/%5B/g, '[');		// [] does not need to be encoded
	queryString = queryString.replace(/%5D/g, ']');		// [] does not need to be encoded
	queryString = queryString.replace(/[^&=]+=(&|$)/g, '');	// Remove empty params
	queryString = queryString.replace(/&$/g, '');		// Remove trailing &

	// Protects against performing same search multiple times. (e.g. on change listener debounces and user pushes enter causing 'submit)
	if (lastSearchQueryString === queryString) {
		return;
	}
	lastSearchQueryString = queryString;

	const url = $form.attr('action');

	$.ajax({
		type: 'GET',
		url,
		data: queryString,

		// Ajax status
		beforeSend: () => {
			startSpinner($form);
		},
		complete: () => {
			stopSpinner($form);
		},

		success: function(data) {
			const $response = $(data);

			const rerender = $form.attr('data-ajax-rerender');

			$rerender.replaceWith(
				$response.find(rerender)
			);

			if (updateState) {
				let pushUrl = url;
				if (queryString) {
					pushUrl += '?' + queryString;
				}
				history.pushState({stateFrom: 'search'}, '', pushUrl);
			}
		}
	});
}


/***************************************************
 * WooCommerce -Multiple images on variable products
 * By default in WC the 'base' products (simple, etc) can have a gallery. The
 * variations (children) cannot. We have "wpackagist-plugin/wc-variation-images"
 * installed, which is a plugin that adds the funcitionality. But, that plugin's
 * frontend.js file listens for 'blur' on drop downs to update the frontend
 * gallery. WC updates what is on the page as soon as 'change' happens. This code
 * listens for the change, on the hidden field variation_id which WC updates, an
 * triggers then triggers a blur on a dropdown so that the plugins 'blur' listener
 * triggers and updates the gallery.
 */
function wc_variation_images_updateGallery() {
	// For some reason value changes twice. We can ignore the blank one
	const variationId = $('input.variation_id').val();
	if (variationId != '') {
		$('form.variations_form table.variations select').first().trigger('blur')
	}
}
$('input.variation_id').on('change', function() {
	wc_variation_images_updateGallery();
}); 